import { useMemo, useCallback } from 'react';
import fp from 'lodash/fp';

import { usePaginationRequests } from 'Modules/business/data';

import { SliderPaginationParameters } from './types';


export const useSliderPagination = <ElType extends { Id: string } | { id: string}>({
    elementsViewCount = 1, path, parameters = {}, step,
}: SliderPaginationParameters) => {
    const { storage, needFetch, fetching, allLoaded, elements, total = 0 } =
    usePaginationRequests<ElType>(path, parameters, step);

    const totalElements = useMemo<ElType[]>(() =>
        fp.map((number: number) => storage && storage[elements[number]])(fp.range(0, total)),
    [storage, total, elements]);

    const needShowElement = useCallback(() => !fetching && !allLoaded && needFetch(), [
        fetching,
        allLoaded,
        needFetch,
    ]);

    const disableSlider = useMemo(() => total <= elementsViewCount,
        [total, elementsViewCount]);
    return {
        totalElements,
        needShowElement,
        disableSlider,
    };
};
